/* Package JSON Import will be here */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    withRouter
} from 'react-router-dom';
/* Package JSON Import will be here */

/* Project Import will be here */
import ReportComponent from './report.Component';

/* Const,Let & Var will be here */
/* Const,Let & Var will be here */

class Report extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReportClicked: true,
            ReportScheduleDataList:[]  
        };
    }

    onClickReport(){
        this.setState({
            isReportClicked: true 
        });
    }
    
    render() {
        const { isReportClicked } = this.state;
        return (
            <Fragment>
                <ReportComponent
                    {...{
                        report: {
                            isReportClicked
                        }
                    }}
                    user={this.props.user}
                    onClickReport={this.onClickReport.bind(this)}                    
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user
    };
}

export default withRouter(connect(mapStateToProps)(Report));

Report.displayName = 'Report';